<div class="container">
  <div class="row mt-2">
    <div class="col-lg-7 col-12 mt-3">
      <span class="font-size-18 font-heading-bold text-uppercase">{{ 'cart.checkout.title' | translate }}</span>
      <fgb-cart-item></fgb-cart-item>
      <button class="btn text-error fw-bold ps-0" (click)="goBack()" aria-label="Back">
        <span class="font-size-14">{{ 'cart.checkout.cancel' | translate }}</span>
      </button>
    </div>
    <div class="col-lg-5 col-12 mt-3">
      <!--member details address-->
      <div class="container border rounded p-3 mb-3" [ngClass]="{ 'd-none': editingMemberAddress }">
        <div class="position-relative">
          <div class="row">
            <div class="col-10 d-flex justify-content-between">
              <span class="font-size-14">{{ 'cart.checkout.billing' | translate }}</span>
            </div>
            <div class="col-2 text-end">
              <a class="cursor-pointer font-sans-bold text-primary font-size-14" (click)="editMemberAddress()">{{
                'cart.checkout.edit' | translate
              }}</a>
            </div>
          </div>
          <div>
            <span *ngIf="memberDetail$ | async as member" class="font-size-14 mb-0">
              <div>
                {{ member.Street }}, {{ member.Town }}, {{ member.County }}, {{ member.Country }}, {{ member.PostCode }},
                {{ member.HomeNumber }}
              </div>
            </span>
          </div>
        </div>
      </div>
      <!--EO member details address view-->

      <!-- EDIT MEMBER DETAILS ADDRESS FORM -->
      <ng-container *ngIf="editingMemberAddress">
        <div class="border rounded container mb-3">
          <div class="position-relative p-2">
            <div class="d-flex justify-content-between">
              <h4 class="font-size-14 pt-2 mb-3 text-capitalize">
                {{ 'cart.checkout.page.billing.address.title' | translate }}
              </h4>
              <a
                (click)="clearAddressForm(memberAddressForm)"
                class="text-primary heading-text-one mb-1 pt-2 font-size-14 cursor-pointer fw-bold"
                >{{ 'cart.checkout.page.address.form.clear' | translate }}</a
              >
            </div>

            <form [formGroup]="memberAddressForm" class="font-size-12">
              <!--Street-->
              <div class="form-floating mb-3">
                <input
                  id="Street"
                  class="form-control"
                  name="Street"
                  type="text"
                  formControlName="Street"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Street.errors,
                  }"
                  required
                />
                <label for="Street">
                  <span>{{ 'cart.checkout.page.form.street' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.checkout.page.form.street.invalid' | translate }}</div>
              </div>
              <!--City-->
              <div class="form-floating mb-3">
                <input
                  id="Town"
                  class="form-control"
                  name="Town"
                  type="text"
                  formControlName="Town"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.Town.errors,
                  }"
                  required
                />
                <label for="Town">
                  <span>{{ 'cart.checkout.page.form.city' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.checkout.page.form.city.invalid' | translate }}</div>
              </div>
              <!--Country and region-->
              <fgb-country-and-regions
                [SeparateRow]="true"
                [Form]="memberAddressForm"
                [RegionLabel]="'State'"
                [HasSubmitted]="hasSubmittedMemberAddress"
              ></fgb-country-and-regions>
              <!--Zip code-->
              <div class="form-floating mb-3">
                <input
                  id="Postcode"
                  class="form-control"
                  name="Postcode"
                  type="text"
                  formControlName="PostCode"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.PostCode.errors,
                  }"
                  required
                />
                <label for="Postcode">
                  <span>{{ 'cart.checkout.page.form.postcode' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.checkout.page.form.postcode.invalid' | translate }}</div>
              </div>
              <!--Phone-->
              <div class="form-floating mb-3">
                <input
                  id="HomeNumber"
                  class="form-control"
                  name="HomeNumber"
                  type="text"
                  formControlName="HomeNumber"
                  [ngClass]="{
                    'is-invalid': hasSubmittedMemberAddress && !!memberAddressForm.controls.HomeNumber.errors,
                  }"
                  required
                />
                <label for="Country">
                  <span>{{ 'cart.checkout.page.form.phone' | translate }}</span>
                </label>
                <div class="invalid-feedback">{{ 'cart.checkout.page.form.phone.invalid' | translate }}</div>
              </div>
            </form>

            <div class="d-flex justify-content-between my-2 font-size-14">
              <button class="btn btn-primary fw-bold btn-cancel-save" (click)="cancelAndRebuildForm()">
                {{ 'cart.checkout.page.form.cancel' | translate }}
              </button>
              <button class="btn btn-success fw-bold btn-cancel-save" (click)="saveMemberDetailAddress()">
                {{ 'cart.checkout.page.form.save' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--EO edit member details address-->
      <fgb-errors></fgb-errors>
      <!--summary of items in basket-->
      <ng-container>
        <div class="container border rounded p-3">
          <span class="font-sans-bold font-size-14">{{ 'cart.checkout.summary' | translate }}</span>
          <div class="row mt-2">
            <div class="col-6 font-size-14">{{ 'cart.checkout.item' | translate }}</div>
            <ng-container *ngIf="isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end">{{ totalPriceMerchantValue / 100 | FortressCurrencyPipe }}</div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="col-6 font-size-14 text-end pe-4">{{ totalItems$ | async }}</div>
            </ng-container>
          </div>
          <ng-container *ngIf="isShippingEnable">
            <div class="row text-white">
              <div class="col-6 fw-bold font-size-14">
                <span class="fw-normal">{{ 'cart.summary.shipping.amount' | translate }}</span>
              </div>
              <div class="col-6 font-size-14 text-end pr-4">{{ shippingamountValue / 100 | FortressCurrencyPipe }}</div>
            </div>
          </ng-container>
          <hr />
          <div class="row">
            <div class="col-6 fw-bold font-size-14">{{ 'cart.checkout.total' | translate }}</div>
            <ng-container *ngIf="totalBasketPriceValue > 0">
              <div class="col-6 fw-bold font-size-14 text-end">{{ totalBasketPriceValue / 100 | FortressCurrencyPipe }}</div>
            </ng-container>
            <ng-container *ngIf="!isListHasMerchantItem">
              <div class="col-6 fw-bold font-size-14 text-end">{{ totalPoints | FortressCurrencyPipe: 'PTS' }}</div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div class="payment-type-container">
        <p class="title">{{ 'cart.payment' | translate }}</p>
        <ng-container *ngIf="items$ | async as items">
          <ng-container *ngIf="cardInfor.CardNumber">
            <div class="card-infor d-flex">
              <p class="font-size-14">{{ 'cart.card_infor' | translate }}</p>
              <p class="card-number font-size-14 ms-2">({{ cardInfor.CardNumber | creditCardNumber | slice: -4 }})</p>
            </div>
            <div class="d-flex">
              <ng-container [ngSwitch]="cardInfor!.CardType">
                <img class="payment-logo" *ngSwitchCase="1" src="assets/images/payment-icons/_Mastercard.svg" />
                <img class="payment-logo" *ngSwitchCase="2" src="assets/images/payment-icons/_AMEX.svg" />
                <img class="payment-logo" *ngSwitchCase="3" src="assets/images/payment-icons/_Visa.svg" />
                <img class="payment-logo" *ngSwitchCase="4" src="assets/images/payment-icons/_Discover.svg" />
                <img class="payment-logo" *ngSwitchCase="5" src="assets/images/payment-icons/_JCB.svg" />
                <img class="payment-logo" *ngSwitchCase="7" src="assets/images/payment-icons/_DinnersClub.svg" />
                <img class="payment-logo" *ngSwitchCase="8" src="assets/images/payment-icons/_UnionPay.svg" />
                <div class="payment-logo" *ngSwitchDefault></div>
              </ng-container>
              <span class="ms-2 text-info font-size-14">
                {{ 'card.exp' | translate }} {{ cardInfor?.ExpiryDate | date: 'MM/yy' }}
              </span>
            </div>
            <div class="px-0 my-2">
              <button
                class="btn btn-success fw-bold mt-2 w-100 paynow-btn"
                (click)="payNow()"
                [disabled]="!validCheckout || totalPoints > currentBalance || !cardInfor.CardNumber"
              >
                {{ statusText }}
              </button>
            </div>
            <div class="d-flex align-items-center mb-2">
              <hr class="w-100" />
              <span class="mx-2 font-size-12 text-info">{{ 'cart.payment.or' | translate }}</span>
              <hr class="w-100" />
            </div>
          </ng-container>
        </ng-container>

        <a class="payment-btn w-100 d-flex justify-content-center" [routerLink]="['/ecash']">
          {{ 'cart.payment_button' | translate }}
        </a>
        <!-- <div class="checkbox-container d-flex align-items-center">
          <input type="checkbox" id="checkbox" class="checkbox" />
          <p class="description">{{ 'cart.save_payment_card' | translate }}</p>
        </div> -->
      </div>
    </div>
  </div>
</div>
